export default "__VITE_ASSET__CqyjAlfC__"